import { ROLE_KIND } from './copy.js';

/** `system` | `custom`. System-role NAMES are backend data and never live in constants. */
export const ROLE_TYPES = ROLE_KIND;

/** Ids of the role detail tabs. */
export const ROLE_TAB = Object.freeze({ MEMBERS: 'members', PERMISSIONS: 'permissions' });

/** Detail tabs of a role, in display order. `id` is the tab state, `labelKey` an i18n key. */
export const ROLE_DETAIL_TABS = Object.freeze([
  { id: ROLE_TAB.MEMBERS, labelKey: 'roles.detail.tabs.members' },
  { id: ROLE_TAB.PERMISSIONS, labelKey: 'roles.detail.tabs.permissions' },
]);

/** Tab shown when a role is opened. */
export const DEFAULT_ROLE_TAB = ROLE_TAB.MEMBERS;

/** Page size used to read every member of a role / of the workspace for the mock service. */
export const ROLE_MEMBERS_PAGE_SIZE = 200;
